// extracted by mini-css-extract-plugin
module.exports = {"AnswersList":"_8k9Jp5qAqNPReHxCWQVa0"};